<div class="flex flex-1 flex-col">
  <ng-container *ngIf="currentBac$ | async as currentBac; else loading_header">
    <ng-container *ngIf="isBacShoutsOut(currentBac); else basic_library">
      <!-- BEGIN SHOUT OUT -->
      <rk-library-header
        [currentBac]="currentBac"
        [tracksTime]="tracksTime$ | async"
        (changeSearch)="onChangeSearch($event)"
        [fullHeader]="
          planBigger(planDesc$ | async, 'Start') &&
          (shoutOuts$ | async)?.enabled &&
          (tracksUnfiltered$ | async) &&
          (tracksUnfiltered$ | async).length > 0
        "
        [displayedTracks]="(tracks$ | async) && (tracks$ | async).length"
        [isCurrentlyFiltered]="isCurrentBacWithFilters$ | async"
        [plan]="planDesc$ | async"
        [shoutOutsEnabled]="(shoutOuts$ | async)?.enabled"
        #bacHeader
      ></rk-library-header>
      <ng-container
        *ngIf="
          planBigger(planDesc$ | async, 'Start') ||
            ((tracks$ | async) && (tracks$ | async).length > 0);
          else no_plan_shoutouts
        "
      >
        <ng-container *ngIf="!(isLoading$ | async); else loading_medialist">
          <ng-container
            *ngIf="
              (shoutOuts$ | async).enabled ||
                ((tracks$ | async) && (tracks$ | async).length > 0);
              else shoutouts_disabled
            "
          >
            <rk-library-audio-table
              class="flex flex-1 flex-col"
              *ngIf="(tracks$ | async) !== null; else loading_medialist"
              [tracks]="tracks$ | async"
              [columns]="columns$ | async"
              (columnsToggle)="onColumnChange($event)"
              [bacLength]="(tracksUnfiltered$ | async)?.length"
              [importingDefaultTracks]="isImportingDefaultTracks$ | async"
              [currentBacName]="currentBac.name"
              [currentBac]="currentBac"
              [searchField$]="searchSubject.asObservable()"
              [isCurrentlyFiltered]="isCurrentBacWithFilters$ | async"
            ></rk-library-audio-table>
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- END SHOUT OUT -->
    </ng-container>

    <ng-template #basic_library>
      <rk-library-header
        [currentBac]="currentBac"
        [tracksTime]="tracksTime$ | async"
        (changeSearch)="onChangeSearch($event)"
        [fullHeader]="
          (tracksUnfiltered$ | async) && (tracksUnfiltered$ | async).length > 0
        "
        [plan]="planDesc$ | async"
        [displayedTracks]="(tracks$ | async) && (tracks$ | async).length"
        [isCurrentlyFiltered]="isCurrentBacWithFilters$ | async"
        #bacHeader
      ></rk-library-header>

      <ng-container *ngIf="!(isLoading$ | async); else loading_medialist">
        <rk-library-audio-table
          class="flex flex-1 flex-col"
          *ngIf="(tracks$ | async) !== null; else loading_medialist"
          [tracks]="tracks$ | async"
          [columns]="columns$ | async"
          (columnsToggle)="onColumnChange($event)"
          [bacLength]="(tracksUnfiltered$ | async)?.length"
          [importingDefaultTracks]="isImportingDefaultTracks$ | async"
          [currentBacName]="currentBac.name"
          [currentBac]="currentBac"
          [searchField$]="searchSubject.asObservable()"
          [isChronic]="isBacChronic(currentBac)"
          [isCurrentlyFiltered]="isCurrentBacWithFilters$ | async"
          [bacPlanLocked]="
            currentBac.name === '__CHRONIC__' && planBigger('Start', planDesc$ | async)
          "
        ></rk-library-audio-table>
      </ng-container>
    </ng-template>
  </ng-container>
</div>

<ng-template #loading_header>
  <div class="header loading-header">
    <rk-loader [isLoading]="true" [size]="60"></rk-loader>
  </div>
</ng-template>

<ng-template #loading_medialist>
  <div class="mt-32">
    <rk-loader [isLoading]="true" [size]="60" [center]="true"></rk-loader>
  </div>
</ng-template>

<ng-template #no_plan_shoutouts>
  <div class="disabled-container">
    <img src="assets/shout-outs-locked.svg" />
    <span translate>MEDIA.SHOUTOUTS.PLAN_INSUFFICIENT</span>
    <span class="details" translate>MEDIA.SHOUTOUTS.PLAN_INSUFFICIENT_DETAILS</span>
    <rk-button
      [label]="'GLOBAL.NOACCESS.UPGRADE' | translate"
      (click)="updateOffer()"
    ></rk-button>
  </div>
</ng-template>

<ng-template #shoutouts_disabled>
  <div class="disabled-container">
    <img src="assets/shout-outs.svg" /> <span translate>MEDIA.SHOUTOUTS.NOT_ENABLED</span>
    <rk-button
      *rkHasRole="'__widgets__'"
      [label]="'MEDIA.SHOUTOUTS.ENABLE' | translate"
      (click)="enableShoutOuts()"
    ></rk-button>
  </div>
</ng-template>

<router-outlet></router-outlet>
